import React from "react";

export function Logo({ size = 32, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 3C15.7 3 9 9.7 9 18c0 10.5 13.2 25 13.8 25.6a1.7 1.7 0 0 0 2.4 0C25.8 43 39 28.5 39 18 39 9.7 32.3 3 24 3Z"
          fill="#D9A441"
        />
        <circle cx="24" cy="18" r="8.5" fill="#0A1224" />
        <circle cx="24" cy="18" r="4" fill="#D9A441" />
        <circle cx="26" cy="16" r="1.4" fill="#F4C458" />
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-[15px] tracking-tight text-white">LOCAL</div>
          <div className="font-heading font-extrabold text-[15px] tracking-tight text-gold -mt-0.5">CREATOR</div>
        </div>
      )}
    </div>
  );
}
